import { ModalHandler } from '@app-velocity/ui';

import { SecurityPolicyModalContent } from './components/SecurityPolicyModalContent';

export const SecurityPolicyModal = () => {
  return (
    <ModalHandler
      id="security-policy"
      channel="users"
    >
      <SecurityPolicyModalContent />
    </ModalHandler>
  );
};
